const EMPLOYMENT_DATE_MIN_YEAR = 1900;
const EMPLOYMENT_DATE_MAX_YEAR = 2100;

export const agentEmploymentDateToday = () => new Date().toISOString().slice(0, 10);

export const formatAgentEmploymentDate = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const s = String(value).slice(0, 10);
  if (s === "0000-00-00" || s.startsWith("0000-00-00")) return "";
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "";
  const y = parseInt(s.slice(0, 4), 10);
  if (y < EMPLOYMENT_DATE_MIN_YEAR || y > EMPLOYMENT_DATE_MAX_YEAR) return "";
  return s;
};

/** type=date onChange — geçersiz yıl (0002 vb.) state'e yazılmasın */
export const isAgentEmploymentDateInputAllowed = (value) => {
  if (value === "" || value == null) return true;
  const s = String(value).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
  const y = parseInt(s.slice(0, 4), 10);
  if (y < EMPLOYMENT_DATE_MIN_YEAR || y > EMPLOYMENT_DATE_MAX_YEAR) return false;
  const d = new Date(`${s}T12:00:00`);
  if (Number.isNaN(d.getTime())) return false;
  return d.toISOString().slice(0, 10) === s;
};

export const isValidAgentEmploymentDateInput = isAgentEmploymentDateInputAllowed;
